import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './confirmation.component'

import ManagePurchaseNavbar from '../common/manage-purchase-navbar'
import ManagePurchaseTopblock from '../common/manage-purchase-topblock'

let module = angular.module('confirmation', [
  uiRouter,
  ManagePurchaseNavbar,
  ManagePurchaseTopblock
])

.config(($stateProvider, $urlMatcherFactoryProvider) => {
  'ngInject'
  $urlMatcherFactoryProvider
    .type('boolean', {
      name: 'boolean',
      decode: (val) => { return val === true ? true : val === 'true' },
      encode: (val) => { return val === true }
    })
  $stateProvider
    .state('managePurchase.confirmation', {
      url: '/:productId/confirmation?status&order&amount&currency&locale&price&{voucher:boolean}&reduction&{free:boolean}&{direct:boolean}',
      params: {
        productId: null
      },
      component: 'confirmation',
      authenticate: true
    })
})

.component('confirmation', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/confirmation/index.js